export default __webpack_public_path__ + "static/media/V360_CoC.14a0bedc.pdf";